<template>
  <div
    :data-test="dataTest"
    :class="[
      'center-block',
      isDesktop ? 'w-50' : 'w-75'
    ]">
    <img
      :class="customClass"
      :src="customImage || image"
      class="center-block empty-page__drunkie"
      alt="Empty page">
    <div
      class="text-center mt-4">
      <div
        v-if="$slots.heading"
        class="font-format--display-m font-weight-bold">
        <slot name="heading" />
      </div>
      <div
        v-if="$slots.subheading"
        class="mt-4 font-format--display-s">
        <slot name="subheading" />
      </div>
    </div>
    <div
      v-if="$slots.buttons"
      class="mt-4">
      <slot name="buttons" />
    </div>
  </div>
</template>

<script>
import manInBox from 'frontcore/assets/images/empty_page_man_in_a_box.svg'
import UserAgent from 'frontcore/utils/userAgent'

export default {
  name: 'EmptyPageCard',
  props: {
    customImage: {
      type: String,
    },
    customClass: {
      type: String,
      default: '',
    },
    dataTest: {
      type: String,
      default: "empty-page-card",
    },
  },
  data () {
    return {
      image: manInBox,
      isDesktop: UserAgent.isDesktopWidth(),
    }
  },
}
</script>

<style scoped>

  .empty-page__drunkie {
    max-width: 100%;
    max-height: 19.25rem;
  }

</style>
